import {ModerationItem, ModerationItemDTO, ModerationMapper} from './moderation.type';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, map } from 'rxjs';

@Injectable()
export class ModerationService {

    constructor(private http: HttpClient) { }

    async listModerationRequests() {
        return await firstValueFrom(this.http.get<ModerationItemDTO[]>(`/admin/moderation/`).pipe(
            map((requests: ModerationItemDTO[]) => requests.map(dto => ModerationMapper.fromDto(dto))))
        )
    }

    async review(item: ModerationItem) {
        return await firstValueFrom(this.http.post(`/admin/moderation/review`, item));
    }

    async restore(item: ModerationItem) {
        return await firstValueFrom(this.http.post(`/admin/moderation/restore`, item));
    }

    async moderate(item: ModerationItem) {
        return await firstValueFrom(this.http.post(`/admin/moderation/moderate`, item));
    }
}